<script setup lang="ts">
import type { TBriefing } from '~/types/briefings'

type TProps = {
  briefings: TBriefing[]
}

defineProps<TProps>()
</script>

<template>
  <BaseSection title="Briefings" data-testid="briefings-section">
    <h1
      v-if="briefings?.length === 0"
      class="text-center font-semibold text-lg md:text-xl mb-6"
    >
      No briefings available at the moment.
    </h1>
    <template v-else>
      <div
        class="grid grid-cols-1 sm:grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4 w-full"
      >
        <BriefingCard
          v-for="briefing in briefings"
          :key="briefing.slug"
          :title="briefing.archiveTitle"
          :publication-frequency="briefing.publicationFrequency"
          :date="briefing.date"
          :slug="briefing.slug"
          :image="briefing.image"
          :viewer-can-read="briefing.viewerCanRead"
          :excerpt="briefing.excerpt"
          :time-to-read="briefing.timeToRead"
          :link="briefing.link"
        />
      </div>
      <div class="mt-2 flex justify-center md:mt-10">
        <BaseLink
          variant="tertiary"
          href="/publications/briefings"
          data-testid="see-more-briefings-link"
        >
          <span class="md:hidden">See more</span>
          <span class="hidden md:block">Click to view more Briefings</span>
        </BaseLink>
      </div>
    </template>
  </BaseSection>
</template>
